import {
  AccountTree,
  AdminPanelSettings,
  Apartment,
  Apps as AppsIcon,
  Assignment,
  AutoAwesome,
  AutoFixHigh,
  BadgeOutlined,
  BusinessCenter,
  Campaign,
  ContactMail,
  Contacts,
  AttachMoney as DollarSign,
  Email,
  EmojiEvents,
  FactCheck,
  FileUpload,
  Folder,
  Forum,
  Groups,
  Home,
  Inbox,
  Insights,
  IntegrationInstructions,
  Inventory2,
  ListAlt,
  NotificationsActive,
  Person,
  PublishedWithChanges,
  QuestionAnswer,
  Router,
  Settings,
  SmartToy,
  Sports,
  SupportAgent,
  TrendingUp,
  Tune,
  Work
} from "@mui/icons-material";

import InlineSVG from "react-inlinesvg";

type Props = {
  name: string;
};

function IconRender(props: Props) {
  const { name } = props;

  const renderMUIIcon = (iconName: string) => {
    switch (iconName) {
      case "Home":
        return <Home />;
      case "Inbox":
        return <Inbox />;
      case "Insights":
        return <Insights />;
      case "Apps":
        return <AppsIcon />;
      case "SupportAgent":
        return <SupportAgent />;
      case "Work":
        return <Work />;
      case "BadgeOutlined":
        return <BadgeOutlined />;
      case "Sports":
        return <Sports />;
      case "SmartToy":
        return <SmartToy />;
      case "AccountTree":
        return <AccountTree />;
      case "Admin":
        return <AdminPanelSettings />;
      case "Apartment":
        return <Apartment />;
      case "Groups":
        return <Groups />;
      case "Person":
        return <Person />;
      case "PublishedWithChanges":
        return <PublishedWithChanges />;
      case "Router":
        return <Router />;
      case "BusinessCenter":
        return <BusinessCenter />;
      case "Campaign":
        return <Campaign />;
      case "Inventory2":
        return <Inventory2 />;
      case "IntegrationInstructions":
        return <IntegrationInstructions />;
      case "Forum":
        return <Forum />;
      case "EmojiEvents":
        return <EmojiEvents />;
      case "FileUpload":
        return <FileUpload />;
      case "Folder":
        return <Folder />;
      case "Files":
        return <Folder />;
      case "Assignment":
        return <Assignment />;
      case "AutoAwesome":
        return <AutoAwesome />;
      case "Settings":
        return <Settings />;
      case "ListAlt":
        return <ListAlt />;
      case "DollarSign":
        return <DollarSign />;
      case "TrendingUp":
        return <TrendingUp />;
      case "AutoFixHigh":
        return <AutoFixHigh />;
      case "NotificationsActive":
        return <NotificationsActive />;
      case "ContactMail":
        return <ContactMail />;
      case "Contacts":
        return <Contacts />;
      case "Email":
        return <Email />;
      case "FactCheck":
        return <FactCheck />;
      case "QuestionAnswer":
        return <QuestionAnswer />;
      case "Tune":
        return <Tune />;
      default:
        return null;
    }
  };

  const renderSVGIcon = (iconName: string) => {
    switch (iconName) {
      case "Leaderboard":
        return "/images/sidebar/task.svg";
      case "CreditCard":
        return "/images/sidebar/app_pages.svg";
      case "Build":
        return "/images/sidebar/tool.svg";
      case "InsertDriveFile":
        return "/images/sidebar/system.svg";
      case "RocketLaunch":
        return "/images/sidebar/audit.svg";
      case "Android":
        return "/images/sidebar/Circle.svg";
      case "Circle":
        return "/images/sidebar/Circle.svg";
      case "Today":
        return "/images/sidebar/Circle.svg";
      case "Smile":
        return "/images/sidebar/smile.svg";
      case "Setting":
        return "/images/sidebar/cog.svg";
      case "Performance":
        return "/images/sidebar/performance.svg";
      default:
        return null;
    }
  };

  const muiIcon = renderMUIIcon(name);
  const svgIcon = renderSVGIcon(name);

  // Only pass string src to InlineSVG, otherwise render nothing
  return (
    <div className="icon">{muiIcon ? muiIcon : typeof svgIcon === "string" ? <InlineSVG src={svgIcon} /> : null}</div>
  );
}

export default IconRender;
